import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/home/footer.png'
import _imports_1 from '@/assets/mobile/f.png'
import _imports_2 from '@/assets/home/c.png'
import _imports_3 from '@/assets/home/tt.png'
import _imports_4 from '@/assets/home/d.png'
import _imports_5 from '@/assets/home/ins.png'
import _imports_6 from '@/assets/home/tg.png'


const _hoisted_1 = { class: "footer scroll-fade" }
const _hoisted_2 = { class: "footer-info" }
const _hoisted_3 = { class: "footer-link" }

import { xUrlApi, tgUrlApi, insUrlApi, disUrlApi } from "@/api/other";


export default /*@__PURE__*/_defineComponent({
  __name: 'footer',
  setup(__props) {

const goPathUrl = async (type: string) => {
  let api;
  switch (type) {
    case "tg":
      api = tgUrlApi;
      break;
    case "dis":
      api = disUrlApi;
      break;
    case "ins":
      api = insUrlApi;
      break;
    case "x":
      api = xUrlApi;
      break;
  }

  if (api) {
    const res = await api();
    if (res.code === 200 && res.data) {
      window.location.href = res.data;
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "footer-icon"
    }, null, -1)),
    _cache[6] || (_cache[6] = _createElementVNode("img", {
      src: _imports_1,
      alt: "",
      class: "mobile-footer-icon"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "time" }, [
        _createElementVNode("img", {
          src: _imports_2,
          alt: "",
          class: "c-icon"
        }),
        _createTextVNode(" 2024 ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_3,
          alt: "",
          class: "footer-tt-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goPathUrl('x')))
        }),
        _createElementVNode("img", {
          src: _imports_4,
          alt: "",
          class: "footer-d-icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goPathUrl('dis')))
        }),
        _createElementVNode("img", {
          src: _imports_5,
          alt: "",
          class: "footer-ins-icon",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goPathUrl('ins')))
        }),
        _createElementVNode("img", {
          src: _imports_6,
          alt: "",
          class: "footer-ins-icon margin-left-two",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (goPathUrl('tg')))
        })
      ])
    ])
  ]))
}
}

})